import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { BestServiceAPI } from "@api";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  HeaderSection,
  FooterSection,
  LeafBox,
  Accordion,
  BenefitBox,
} from "@components";
import { TitleComponent } from "../../../common/components/TitleComponent";
import GooglePlay from "../../../assets/images/google-play-badge.png";
import AppStore from "../../../assets/images/app-store-badge.png";
import GooglePlayEn from "../../../assets/images/google-play-badge-en.png";
import AppStoreEn from "../../../assets/images/app-store-badge-en.png";
import BukopinMobile from "../../../assets/images/bukopin-mobile.png";

import "./IndividuDetail.scss";

const Container = styled.div`
  background-color: #ffffff;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const SimpleBox = styled.div`
  font-size: 16px;
  line-height: 150%;
  color: #5e514d;

  ol,
  ul {
    padding-left: 1em;
  }
`;

const Badge = styled.img`
  cursor: pointer;
  height: 2em;
  width: 111px;
  padding-right: 5px;
  z-index: 2;
`;

const BadgeIos = styled.img`
  cursor: pointer;
  height: 2em;
  width: 99px;
  z-index: 2;
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const setSize = (il, index) => {
  let size = il === 2 ? 6 : 4;
  if (il > 3) {
    const mod = il % 3;
    if (mod === 1 && index === il - 1) {
      size = 12;
    } else if (mod === 2 && (index === il - 1 || index === il - 2)) {
      size = 6;
    }
  }

  return size;
};

const IndividuDetail = function () {
  const { t, i18n } = useTranslation();

  const { id } = useParams();
  const [data, setdata] = useState({});
  const [isLoading, setisLoading] = useState(false);

  const loadData = async function () {
    setisLoading(true);
    const { data } = await BestServiceAPI(`/${id}`);

    setisLoading(false);
    setdata(data.data);    
  };

  useEffect(() => {
    loadData();
  }, []);

  const simpletext = {
    before_feature: [],
    after_feature: [],
  };

  const accordion = {};
  const accordion2 = {};

  if (
    typeof data.blockDataAccordion1 != "undefined" &&
    data.blockDataAccordion1.length > 0
  ) {
    data.blockDataAccordion1.map((item, index) => {
      let title = item.subTitleAccordion;
      let group = data.accordionTitle;

      if (title.indexOf("}") > -1) {
        const tmp = title.split("}");
        group = tmp[0].replace("{", "").trim();
        title = tmp[1].trim();
      }

      if (
        ["before_feature", "after_feature"].indexOf(group.toLowerCase()) > -1
      ) {
        simpletext[group].push(
          <div style={{marginBottom: '60px'}}>
            <h2 className="mt-2 mb-2 section-title">{title}</h2>
            <SimpleBox
              dangerouslySetInnerHTML={{ __html: item.contentAccordion }}
            />
          </div>
        );
      } else {
        if (typeof accordion[group] == "undefined") {
          accordion[group] = [];
        }

        accordion[group].push(
          <Accordion key={index} title={title}>
            {item.contentAccordion}
          </Accordion>
        );
      }
    });
  }

  if (
    typeof data.blockDataAccordion2 != "undefined" &&
    data.blockDataAccordion2.length > 0
  ) {
    data.blockDataAccordion2.map((item, index) => {
      let title = item.subTitleAccordion;
      let group = "";

      if (title.indexOf("}") > -1) {
        const tmp = title.split("}");
        group = tmp[0].replace("{", "").trim();
        title = tmp[1].trim();
      }

      if (
        ["before_feature", "after_feature"].indexOf(group.toLowerCase()) > -1
      ) {
        simpletext[group].push(
          <div>
            <h2 className="mt-2 mb-2 section-title">{title}</h2>
            <SimpleBox
              dangerouslySetInnerHTML={{ __html: item.contentAccordion }}
            />
          </div>
        );
      } else {
        if (typeof accordion[group] == "undefined") {
          accordion[group] = [];
        }

        accordion[group].push(
          <Accordion key={index} title={title}>
            {item.contentAccordion}
          </Accordion>
        );
      }
    });
  }

  const hasBeforeFeature =
    typeof simpletext.before_feature != "undefined" &&
    Object.keys(simpletext.before_feature).length > 0
      ? true
      : false;
  const hasAfterFeature =
    typeof simpletext.after_feature != "undefined" &&
    Object.keys(simpletext.after_feature).length > 0
      ? true
      : false;

  return (
    <Container>
      <TitleComponent title={data.title} />
      {!isLoading && (
        <div className="individu-detail">
          <Desktop>
            <HeaderSection
              title={data.title}
              group={t("layanan_terbaik_untuk_anda")}
              description={data.description}
              banner={data.imageBannerDesktop}
              showButton={false}
            />
          </Desktop>
          <Mobile>
            <HeaderSection
              title={data.title}
              group={t("layanan_terbaik_untuk_anda")}
              description={data.description}
              banner={data.imageBannerMobile}
              showButton={false}
            />
          </Mobile>

          <div className="p-0 m-0 container-fluid">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              {hasBeforeFeature && simpletext.before_feature}

              {typeof data.blockDataCard != "undefined" &&
                data.blockDataCard.length > 0 && (
                  <div>
                    {(!hasBeforeFeature || id === "2131") && (
                      <h2 className="mt-5 mb-4 section-title">
                        {i18n.t("label_fitur", { fitur: data.title })}
                      </h2>
                    )}
                    <div className="row">
                      {data.blockDataCard.map((item, index) => {
                        const size = setSize(data.blockDataCard.length, index);
                        const isThin =
                          item.descriptionKeunggulanTabungan === ""
                            ? true
                            : false;
                        return (
                          <LeafBox
                            key={index}
                            number={index + 1}
                            thin={isThin}
                            size={size}
                            title={item.titleDataCard}
                            description={item.descriptionDataCard}
                          />
                        );
                      })}
                    </div>
                  </div>
                )}
              {hasAfterFeature && (
                <div className="mb-4">{simpletext.after_feature}</div>
              )}

              {typeof accordion != "undefined" &&
                Object.keys(accordion).length > 0 && (
                  <div className="mb-5">
                    <div className="row">
                      {Object.keys(accordion).map((group, index) => {
                        return (
                          <div key={index}>
                            <h2 className="section-title">{group}</h2>
                            <div>{accordion[group]}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

              {typeof accordion2 != "undefined" &&
                Object.keys(accordion2).length > 0 && (
                  <div className="mb-5">
                    <div className="row">
                      {Object.keys(accordion2).map((group, index) => {
                        return (
                          <div key={index}>
                            <h2 className="section-title">{group}</h2>
                            <div>{accordion2[group]}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
            {id === "2127" && (
              <div className="wokee-box row mb-5">
                <div className="col-lg-6">
                  <img src={BukopinMobile} className="image" />
                </div>
                <div className="d-flex flex-column justify-content-center col-lg-6">
                  <h3 className="title">{t("BukopinMobile")}</h3>
                  <p className="mb-3">{t("CaraMenabungBukopinMobile")}</p>
                  <div className="d-grid mb-3 col-8">
                    <button
                      onClick={() =>
                        window.open(
                          "https://www.bukopin.co.id/assets/files/Panduan_Aktivasi_Bukopin_Mobile.pdf"
                        )
                      }
                      type="button"
                      className="btn btn-primary btn-lg btn-unduh"
                    >
                      {t("UnduhPanduanTransaksi")}
                    </button>
                    <div class="d-flex align-items-center justify-content-between pt-2">
                      <Badge
                        src={i18n.language === "id" ? GooglePlay : GooglePlayEn}
                        className="btn-store"
                        onClick={() =>
                          window.open(
                            "https://play.google.com/store/apps/details?id=id.co.bukopin.newbkpmobile",
                            "_blank"
                          )
                        }
                      />
                      <BadgeIos
                        src={i18n.language === "id" ? AppStore : AppStoreEn}
                        className="btn-store"
                        onClick={() =>
                          window.open(
                            "https://apps.apple.com/id/app/kb-bukopin-mobile-banking/id1522517881",
                            "_blank"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <FooterSection currentPage={t("layanan_individual")} />
    </Container>
  );
};

export default IndividuDetail;
